import { useForm } from '@mantine/form';
import { useState } from 'react';
import type { StaffPassword } from '../types/OperatorDto';

const defaultPassword: StaffPassword = {
	password: '',
	checkPassword: '',
	id: '',
};

export function useAddStaffPasswordForm(id = '') {
	const [inputs, setInputs] = useState<StaffPassword>({
		...defaultPassword,
		id: id,
	});

	const form = useForm<StaffPassword>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			password: (value) => {
				if (value.length !== 4) {
					return 'Passwords must contain 4 characters';
				}
			},
			checkPassword: (value, values) => {
				if (value !== values.password) {
					return 'Please ensure passwords match';
				}
			},
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
